import {Component} from "react";
import "../styles/SectionTitleStyles.css"

class SectionTitle extends Component {

    constructor(props) {
        super(props);
        this.state = {
            title: this.props.title,
            width: this.props.width
        }
        this.handleResize = this.handleResize.bind(this);
    }

   componentDidMount() {
        window.addEventListener("resize", this.handleResize);
   }

   handleResize() {
        this.setState({width: this.props.width});
   }

    render() {
        if((this.props.width == null || this.props.width == undefined) && window.innerWidth <= 768) {
            this.state.width = 60;
        } else if (this.props.width == null || this.props.width == undefined)  {
            this.state.width = 45;
        }
        return(
            <div className={"section-title"} style={{"width": this.state.width + "%"}}>
                <h3 className={"section-title_value"}>{this.state.title}</h3>
            </div>
        );
    }
}
export default SectionTitle;